import React from "react";
import ClubCardBg from "./ClubCardBg";

function ClubCard({ image, name, data, position }) {
  return (
    <div
      className={`club-card-container rounded-sm text-gray-50 drop-shadow-[0_0_15px_rgba(50,50,50,0.75)] md:ml-1/4 ${
        position === -2 && "second-last-item"
      } ${position === -1 && "last-item"}`}
    >
      <div className="club-card-inner relative h-[300px] w-[250px] rounded-lg p-8 flex items-center justify-center ">
        <ClubCardBg />
        <div className="club-card-front absolute">
          <div className="club-card-img z-[5] drop-shadow-[10px_10px_5px_rgba(0,0,0,0.75)] flex flex-col justify-center">
            <img
              src={image}
              alt=""
              className="h-32 w-auto z-[6] object-contain"
            />
            <p className="w-full text-center pt-4 text-sm">{name}</p>
          </div>
        </div>
        <div className="club-card-back text-justify relative text-sm">
          <div className="club-card-data">
            <p>{data}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClubCard;
